module.exports = __webpack_public_path__ + "static/media/leftlf.3bab49b7.png";